import { Link } from "react-router-dom";

export default function FaqBlock({ faqs }) {
  if (!faqs?.length) return null;
  return (
    <section className="border-t border-zinc-200 mt-16 pt-12" data-testid="faq-block">
      <p className="text-xs font-semibold uppercase tracking-[0.18em] text-zinc-500 mb-3">FAQ</p>
      <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight leading-tight text-zinc-900 mb-8">
        Common questions
      </h2>
      <div className="space-y-6 max-w-3xl">
        {faqs.map((f, i) => (
          <details key={i} className="group border-b border-zinc-200 pb-5">
            <summary className="cursor-pointer list-none flex items-start justify-between gap-4">
              <h3 className="text-base font-medium text-zinc-900 leading-snug">{f.q}</h3>
              <span className="text-zinc-400 group-open:rotate-45 transition-transform text-2xl leading-none mt-[-4px]">
                +
              </span>
            </summary>
            <div className="mt-3 text-sm text-zinc-600 leading-relaxed">{f.a}</div>
          </details>
        ))}
      </div>
    </section>
  );
}

export function CtaBlock({ label = "Start using BreakItDown — free" }) {
  return (
    <div className="border-t border-zinc-200 mt-16 pt-12 text-center">
      <Link
        to="/login"
        className="inline-flex items-center gap-2 px-6 py-3 bg-zinc-900 hover:bg-[#002FA7] text-white text-sm font-medium uppercase tracking-[0.12em] transition-colors"
        data-testid="cta-bottom"
      >
        {label} →
      </Link>
      <p className="text-xs text-zinc-500 mt-3">No credit card. No paid tier.</p>
    </div>
  );
}
